module.exports = __webpack_public_path__ + "img/y_p3_update.6e151d1f.svg";